<script>
export default {
  name: "CommentItem",
  components: { CommentList: () => import("./CommentList.vue") },
  props: {
    commentShowMore: {
      type: Boolean,
      default: true
    },
    comment: {
      type: Object,
      default: () => {}
    },
    canReplay: {
      type: Boolean,
      default: false
    }
  },
  emits: ["reply"],
  data() {
    return {
      subCommentShow: false
    };
  },
  mounted() {
    window.$bus.$on('openSubComment', this.openSubComment);
  },
  beforeDestroy() {
    window.$bus.$off('openSubComment', this.openSubComment);
  },
  methods: {
    openSubComment({id}) {
      if(id === this.comment.id) {
        this.subCommentShow = true;
      }
    },
    onClickSub() {
      this.subCommentShow = !this.subCommentShow;
    },
    onClickReply() {
      this.$emit("reply", this.comment);
    },
  }
};
</script>

<template>
  <div ref="commentItem" class="comment-item mb-5">
    <div class="comment-item__avatar w-10 h-10 mr-3 rounded-full overflow-hidden flex-shrink-0 flex-grow-0">
      <img :src="comment.user.head_url" alt="avatar" class="w-full h-full object-cover">
    </div>
    <div class="comment-item__content flex-1 overflow-hidden">
      <div class="comment-item__content__name text-xs text-gray-500 truncate">{{ comment.user.username }}</div>
      <div class="comment-item__content__text text-sm w-full mb-1">{{comment.content}}</div>
      <div class="flex items-center">
        <div class="comment-item__content__time text-xs text-gray-400 mr-2">{{ comment.created_at }}</div>
<!--        <div class="comment-item__content__location text-xs text-gray-400 mr-4">天津</div>-->
        <div v-if="canReplay" class="comment-item__content__reply text-xs" @click="onClickReply">回复</div>
      </div>
      <div v-if="subCommentShow" class="my-3">
        <CommentList :comment-list="comment.replies" :comment-show-more="false"></CommentList>
      </div>
      <!--   展开   -->
      <div v-if="commentShowMore && comment.replies && comment.replies.length > 0" class="comment-item__content__expand text-xs text-gray-600 mt-2" @click="onClickSub">
        <div v-show="!subCommentShow">
          <i>——</i>
          <span>展开{{ comment.replies.length }}条回复</span>
          <van-icon name="arrow-down"></van-icon>
        </div>
        <div v-show="subCommentShow">
          <i>——</i>
          <span>收起回复</span>
          <van-icon name="arrow-up"></van-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.comment-item {
  @apply flex;
}
.comment-item__content__text {
  /*文本换行*/
  word-wrap: break-word;
}
</style>
